export default "__VITE_ASSET__BiCv2OXq__"